<script>

    import Barba from 'barba.js';
    import { mixin as clickaway } from 'vue-clickaway';

    const hidePageWhileNavigating = true;

    /**
     * Vue Component to use with "inline-template" in twig templates.
     *
     * As long as it is inside a parent vue MODULE (e.g. "VueContainer"), it
     * is mounted automatically and can be nested as far as you want.
     *
     * <demo-component inline-template>
     *    <div class="demoComponent">
     *    </div>
     * </demo-component>
     *
     *
     */
    export default {

        name: 'HeaderComponent',

        mixins: [clickaway],

        data() {
            return {
                activeUris: [],
                activeHasChildren: false,
                activeChildren: null,

                showSearch: false,
                showSearchContent: false,
                showMobileNav: false,

                heights: {
                    header: 39, prem: 24, sec: 0, third: 0, metanav: 0,
                },
                isMobile: false,
            };
        },

        mounted() {
            const isMobile = window.matchMedia('(max-width: 740px)');
            this.isMobile = isMobile.matches;
            window.addEventListener('resize', this.calculateNavigationHeight);
            this.calculateNavigationHeight();
            setTimeout(this.calculateNavigationHeight, 1500);
        },

        methods: {

            clickedOnNavigationLink(uri, ancestorUris, url, isMetaNavigation = false) {

                // Set active uris
                ancestorUris.push(uri);
                this.activeUris = ancestorUris;

                // Get children of selected navigation entry
                this.checkIfActiveHasChildren(uri);

                // Go directly to second nav point, even on mobile
                // if ((hidePageWhileNavigating && !this.isMobile) || !this.activeHasChildren) {
                if ((hidePageWhileNavigating) || !this.activeHasChildren) {
                    this.goToUrl(url);
                    return;
                }

                // Meta navigation entries on the mobile navigation with children:
                // Navigate to first child
                if (isMetaNavigation && this.isMobile && this.activeHasChildren) {
                    this.goToUrl(this.activeChildren.querySelector('a').getAttribute('href'));
                }

            },

            goToUrl(url) {
                this.hideMobileNav(false);
                Barba.Pjax.goTo(url);
            },

            isInActiveUris(uri) {
                return this.activeUris.indexOf(uri) > -1;
            },

            checkIfActiveHasChildren(uri) {
                const parentElement = this.$refs[uri];
                if (parentElement) {
                    const childLists = parentElement.querySelector('ul');
                    this.activeHasChildren = (childLists !== null);
                    this.activeChildren = childLists;
                    return;
                }
                this.activeHasChildren = false;
                this.activeChildren = null;
            },

            setActiveUrisBasedOnUrl(url) {
                const activeLinkElement = this.$el.querySelector(`[href='${url}']`);

                if (activeLinkElement) {
                    if (activeLinkElement.dataset.ancestoruris) {
                        const ancestorUris = JSON.parse(activeLinkElement.dataset.ancestoruris);
                        if (ancestorUris && activeLinkElement.dataset.uri !== undefined) {
                            ancestorUris.push(activeLinkElement.dataset.uri);
                            this.checkIfActiveHasChildren(activeLinkElement.dataset.uri);
                            this.activeUris = ancestorUris;
                        }
                    }
                } else {
                    const urlWithoutQuery = url.split('?')[0];
                    if (urlWithoutQuery !== url) {
                        this.setActiveUrisBasedOnUrl(urlWithoutQuery);
                        return;
                    }
                    const subUri = url.substr(0, url.lastIndexOf('/'));
                    if (subUri !== 'http:/' && subUri !== 'https:/') this.setActiveUrisBasedOnUrl(subUri);
                }
            },

            /*
            * Mobile Navigation Triggers
             */
            hideMobileNav(reset = false) {
                this.showMobileNav = false;
                if (reset) this.setActiveUrisBasedOnUrl(this.activeUrl);
            },

            clickawayMobileNav() {
                this.hideMobileNav(true);
            },

            toggleMobileNav() {
                if (this.showMobileNav) {
                    this.hideMobileNav(true);
                } else {
                    this.showMobileNav = true;
                }
            },

            /*
            * Search Trigger
             */
            hideSearch() {
                this.showSearchContent = false;
            },

            calculateNavigationHeight() {
                this.$nextTick(() => {
                    const isMobile = window.matchMedia('(max-width: 740px)');
                    this.isMobile = isMobile.matches;

                    if (this.isMobile) {
                        this.heights = {
                            header: 0, prem: 0, sec: 0, third: 0, metanav: 0,
                        };
                        return;
                    }

                    // Prem
                    this.heights.header = document.querySelector('.nav-wrap > h1.header-name').clientHeight;

                    // Prem
                    this.heights.prem = document.querySelector('ul.nav-main-list.prem').clientHeight;

                    // Sec
                    this.heights.sec = (document.querySelector('ul.nav-main-list.sec.is-visible') !== null)
                        ? document.querySelector('ul.nav-main-list.sec.is-visible').clientHeight : 0;

                    // Prem
                    this.heights.third = (document.querySelector('ul.nav-main-list.third.is-visible') !== null)
                        ? document.querySelector('ul.nav-main-list.third.is-visible').clientHeight : 0;

                    // metanav (hacky af)
                    // Set a timeout to 500ms if the value is not set yet
                    setTimeout(() => {
                        const metanav = document.querySelector('.nav-wrap .header-metanav');
                        this.heights.metanav = metanav.clientHeight;
                    }, (this.heights.metanav === 0) ? 500 : 0);

                });
            },

            submitSearchForm() {
                this.$refs.searchform.submit();
            },

        },

        computed: {
            activeUrl() {
                return this.$store.state.activeUrl;
            },
            isOnHome() {
                return this.$store.state.isOnHome;
            },
            headerHeight() {
                const height = 75 + this.heights.header + this.heights.prem + this.heights.sec + this.heights.third;// + (Math.min(this.activeUris.length, 2) * 20);
                return this.isMobile ? 'auto' : `${height}px`;
            },
            mobileSubnavIsEmpty() {
                return this.activeUris.length < 2 && !this.activeHasChildren;
            },
            metanavTopPosition() {
                return (this.heights.metanav > 39) ? '-39px' : '-17px';
            },
        },

        watch: {
            activeUrl(url) {
                // Set active uris if url changes
                this.setActiveUrisBasedOnUrl(url);
                this.hideMobileNav();
            },
            showSearchContent(show) {
                if (show) {
                    this.$nextTick(() => {
                        this.$refs.searchInput.focus();
                    });
                }
            },
            activeUris() {
                this.calculateNavigationHeight();
            },
            showMobileNav(showMobileNav) {
                if (showMobileNav && this.isMobile) {
                    const isSmallMobile = window.matchMedia('(max-height: 500px)');
                    if (isSmallMobile.matches) window.scrollTo(0, 0);
                }
            },
        },

    };
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/HeaderComponent.vue